











import { Vue, Component, Prop } from "vue-property-decorator";

const COLOR = {
  STEP_1: { bg: "success", text: "white" },
  STEP_2: { bg: "info", text: "white" },
  STEP_3: { bg: "warning", text: "white" },
  STEP_4: { bg: "yellow", text: "black" },
  STEP_5: { bg: "indigo", text: "white" }
};

const step1Categories = ["nu_gioi", "nam_gioi"];
const step2Categories = [
  "tuoi_18_24",
  "tuoi_25_34",
  "tuoi_35_44",
  "tuoi_45_54",
  "tuoi_55_64",
  "tuoi_65_74",
  "tuoi_tu_75"
];
const step3Categories = ["da_dau", "da_kho", "da_hon_hop", "da_thuong"];
const step4Categories = ["nam_tan_nhang", "mun_viem"];
const step5Categories = ["da_nhay_cam", "bi_chung_do_mat", "none"];

@Component
export default class CategoryChip extends Vue {
  @Prop({ type: String, default: "" })
  category!: string;

  get categoryColor(): string {
    if (this.isStep1) return COLOR.STEP_1.bg;
    if (this.isStep2) return COLOR.STEP_2.bg;
    if (this.isStep3) return COLOR.STEP_3.bg;
    if (this.isStep4) return COLOR.STEP_4.bg;
    if (this.isStep5) return COLOR.STEP_5.bg;
    return "";
  }

  get textColor(): string {
    if (this.isStep1) return COLOR.STEP_1.text;
    if (this.isStep2) return COLOR.STEP_2.text;
    if (this.isStep3) return COLOR.STEP_3.text;
    if (this.isStep4) return COLOR.STEP_4.text;
    if (this.isStep5) return COLOR.STEP_5.text;
    return "";
  }

  get isStep1(): boolean {
    return step1Categories.includes(this.category);
  }

  get isStep2(): boolean {
    return step2Categories.includes(this.category);
  }

  get isStep3(): boolean {
    return step3Categories.includes(this.category);
  }

  get isStep4(): boolean {
    return step4Categories.includes(this.category);
  }

  get isStep5(): boolean {
    return step5Categories.includes(this.category);
  }
}
